module.exports = __webpack_public_path__ + "static/img/down_btn6.03e660c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/down_btn6.png
// module id = 4+oX
// module chunks = 4